var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',{staticClass:"page-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('b-row',[_c('b-col',{attrs:{"xs":"0","lg":"1"}}),_c('b-col',{attrs:{"lg":"10","xs":"12"}},[_c('Widget',[_c('CreativeForm',{attrs:{"id":_vm.id,"view_mode":"full"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }